
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { GroupSchemeScope } from '@/components/mixins/schemescope';

@Component
export default class GroupLevelsModal extends mixins(GroupSchemeScope) {
  @Prop() private nodes!: Array<string>;

  get nodeTitles() {
    return this.nodes.map((node: string) => {
      return this.getNodeName(node);
    });
  }
}
